export default __webpack_public_path__ + "static/media/s3.f70582c8.svg";